import { ModalSize, confirmDelete } from '@ardoq/modal';
import { TagModel } from './types';
import { t, type I18nLocale } from '@ardoq/i18n';

const deleteUnusedTagsDialog = (
  unusedTags: TagModel[],
  i18nLocale: I18nLocale
) =>
  confirmDelete({
    title: t(
      i18nLocale,
      'tabview:tagscape.deleteUnusedDialog.title',
      'Delete all unused tags?'
    ),
    confirmButtonTitle: t(
      i18nLocale,
      'tabview:tagscape.deleteUnusedDialog.confirm',
      'Delete tags'
    ),
    modalSize: ModalSize.XS,
    text: (
      <div>
        <div>
          {t(
            i18nLocale,
            'tabview:tagscape.deleteUnusedDialog.body',
            'The following tags will be deleted:'
          )}
        </div>
        <ul>
          {unusedTags.map(({ name, cid }) => (
            <li key={cid}>{name}</li>
          ))}
        </ul>
      </div>
    ),
  });

export { deleteUnusedTagsDialog };
